import api from './authApi';

export const getFarmerList = (params = {}) => api.get('/farmer', { params });
export const getFarmerStats = () => api.get('/farmer/stats');
export const createFarmer = (payload) => api.post('/farmer', payload);

export const updateFarmer = async (farmerId, payload) => {
  const body = { ...payload, farmerId };
  return api.post('/farmer/update', body);
};

export const saveFarmer = (payload, farmerId) => {
  if (!farmerId) return createFarmer(payload);
  return updateFarmer(farmerId, payload);
};

export const toggleFarmerActive = async (farmerId) => {
  return api.post(`/farmer/${farmerId}/toggle-active`);
};

export const getApiErrorMessage = (err, fallback) => {
  const status = err?.response?.status;
  const msg =
    err?.response?.data?.message ||
    err?.response?.data?.title ||
    err?.message;
  return status ? `${msg || fallback} (HTTP ${status})` : (msg || fallback);
};
